<template>
    <div>
        <portal-target name="video-player"></portal-target>
        <cookies-info></cookies-info>
        <top-search-bar></top-search-bar>
        <heading-section></heading-section>
        <!-- <pandemy-virtual-boxes></pandemy-virtual-boxes> -->
        <segment-news></segment-news>
        <auctions-counter></auctions-counter>
        <!-- <video-info-box></video-info-box> -->
        <pandemy-info-boxes></pandemy-info-boxes>
        <!-- <allegro-footer></allegro-footer> -->
    </div>
</template>

<script>
import cookiesInfo from "@/components/cookies_info";
import topSearchBar from "@/components/top_search_bar";
import allegroFooter from "@/components/allegro_footer";
import headingSection from "@/components/heading_section";
import auctionsCounter from "@/components/auctions_counter";
import segmentNews from '@/components/segment_news';
import pandemyInfoBoxes from '@/components/pandemy_info_boxes';
import videoInfoBox from '@/components/video_info_box';
import pandemyVirtualBoxes from '@/components/pandemy_virtual_boxes';

export default {
    components: {
        topSearchBar,
        allegroFooter,
        headingSection,
        auctionsCounter,
        cookiesInfo,
        segmentNews,
        pandemyInfoBoxes,
        pandemyVirtualBoxes,
        videoInfoBox
    }
};
</script>
